import * as React from 'react';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {
    CreateNewVersionConfirmationDispatchProps,
    CreateNewVersionConfirmationStateProps
} from '../../types/containers';

class AttachmentCreateVersionConfirmationView extends React.Component<CreateNewVersionConfirmationStateProps &
    CreateNewVersionConfirmationDispatchProps, {}> {

    renderButton = (onPressConfirm, onPressClose) => (
        <div>
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onPressClose}>{LOAN_APPLICATION_MX.FILE_DELETE_CANCEL_BUTTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onPressConfirm}>Aceptar</a>
        </div>
    )

    render() {
        const {onPressClose, onPressConfirm, documentType} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify pb-4">
                    <div>Al crear una nueva versión, tendrás que adjuntar nuevos archivos a <b>{documentType.label}</b>.
                    </div>
                    <div className="pt-2">Los archivos asociados actuales se moverán a una versión anterior.</div>
                </div>
                <div className="pt-3 pb-2 px-0 text-right border-top">
                    {this.renderButton(onPressConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default AttachmentCreateVersionConfirmationView;